// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action } from "mobx";
import { MoutebeApi } from '../api/moutebe.api';
import { Booking } from "../models/Booking.model";
import { parseDate } from "../utils/parsers";

export default class MouTeBeStore {
  @observable bookings: Array<any> = [];
  // @observable sanctions: Array<any> = [];
  @observable bookingDetail: Booking = {};

  @action getBookings = async (from?: string, until?: string) => {
    let books = await MoutebeApi.getBookings(from, until);
    this.bookings =
      books &&
      books.map((b: any) => {
        return {
          ...b,
          date: parseDate(b.date, true),
          ret_date: parseDate(b.ret_date, true),
        };
      });
  };

  // @action getSanctions = async (
  //   closed?: boolean,
  //   start?: string,
  //   end?: string
  // ) => {
  //   let res = await MoutebeApi.getSanctions(
  //     closed ? "true" : "false",
  //     start,
  //     end
  //   );
  //   this.sanctions =
  //     res &&
  //     res.map((s: any) => {
  //       return {
  //         ...s,
  //         date: parseDate(s.date, true),
  //         canc_date: parseDate(s.canc_date, true),
  //       };
  //     });
  // };

  @action getBookingDetail = async (id: number) => {
    this.bookingDetail = await MoutebeApi.getBooking(id);
  };
}
